export const HOME_MATCH_BASIC_RESIGNATION_TITLE = "Na pewno chcesz wyłączyć dopasowanie ofert?";

export const HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT = "ZOSTAWIAM DOPASOWANIE OFERT";

export const HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT = "WYŁĄCZAM I SZUKAM SAMODZIELNIE";
export const HOME_MATCH_BASIC_RESIGNATION_TITLE = "Na pewno chcesz wyłączyć dopasowanie ofert?";

export const HOME_MATCH_BASIC_RESIGNATION_KEEP_ENABLED_TEXT = "ZOSTAWIAM DOPASOWANIE OFERT";

export const HOME_MATCH_BASIC_RESIGNATION_DISABLE_TEXT = "WYŁĄCZAM I SZUKAM SAMODZIELNIE";
